// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import api from './config/api'
import App from './App'
import store from './store'
import i18n from './i18n'
import router from './router'
import moment from 'vue-moment'
import Toasted from 'vue-toasted'
import VueAuth from '@websanova/vue-auth'
import VueProgressBar from 'vue-progressbar'
import Vuelidate from 'vuelidate'
import { currency } from '@/filters'
import { uploadPath } from '@/config'
import * as VueGoogleMaps from 'vue2-google-maps'
// import VueFormWizard from 'vue-form-wizard'
// import 'vue-form-wizard/dist/vue-form-wizard.min.css'
// import devExConfig from 'devextreme/core/config'
require('./vendor')

Vue.prototype.$http = api
Vue.prototype.$axios = api
Vue.prototype.$api = api

Vue.config.productionTip = false

Vue.use(moment, {
	moment: require('moment')
})
Vue.use(VueGoogleMaps, {
	load: {
		key: 'AIzaSyAI4i1dCcIdLMmxhFRPrRmmr7LXek8rj1o',
		libraries: 'places',
		language: 'tr',
		region: 'TR'

	}

})

Vue.use(Toasted, {
	iconPack: 'custom-class'
})

Vue.use(VueProgressBar, {
	color: '#fff',
	failedColor: '#e60d3f',
	height: '5px',
	autoRevert: true
})

Vue.use(Vuelidate)

/** vue-auth */
Vue.router = router
Vue.axios = api
 
Vue.filter('currency', currency)

Vue.mixin({
	methods: {
		deepClone: (object) => JSON.parse(JSON.stringify(object)),
		calcImage(image, genderId) {
			if (!image && genderId === 8) {
				return '/static/man-profile.png'
			} else if (!image && genderId === 9) {
				return '/static/woman-profile.png'
			} else {
				return uploadPath + image
			}
		}
	}
})

/* eslint-disable no-new */
new Vue({
	el: '#app',
	store,
	router,
	i18n,
	components: { App },
	template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js